<template>
  <MenuItem
    v-if="isShowMenuItem"
    class="h11-links"
    data-qa="get-tender-protocol"
    :disabled="loading"
    icon="graph"
    :label="$t('Tenders.TenderProtocol')"
    @click="getTenderProtocol"/>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'

import { findComponentsUpward, findComponentsDownward } from 'toolkit/utils/dom'
import { debounce } from 'toolkit/utils/util'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'getTenderProtocol',
  data() {
    return {
      loading: false,
      key: null,
    }
  },
  props: {
    tender: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.findFileList(`getTenderProtocol-${this.tenderId}`)
    this.$root.$on('startFileDownload', this.disableButton)
    this.$root.$on('finishFileDownload', this.enableButton)
  },
  beforeDestroy() {
    this.$root.$off('startFileDownload', this.disableButton)
    this.$root.$off('finishFileDownload', this.enableButton)
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR']),
    isShowMenuItem() {
      return [this.statuseKeys.BID_ANALYSIS, this.statuseKeys.COMPLETED, this.statuseKeys.PURCHASE_NOT_PLACED, this.statuseKeys.CANCELED].includes(this.tender?.tenderStatus?.id)
    }
  },
  methods: {
    /**
     * Ищем компонент с загрузкой файлов и проверяем текущее состояние
     */
    findFileList(key) {
      const defaultApp = findComponentsUpward(this, 'layout')
      if (!defaultApp?.length) {
        this.loading = false
        this.key = null
        return
      }
      const downloadFiles = findComponentsDownward(defaultApp[0], 'download-files')
      if (!downloadFiles?.length) {
        this.loading = false
        this.key = null
        return
      }
      if (downloadFiles[0].files[key]) {
        this.loading = true
        this.key = downloadFiles[0].files[key].key
      }
    },
    /**
     * Блокируем кнопку при совпадении параметров
     */
    disableButton(params) {
      if (params?.method !== 'generateTenderProtocolFile') {
        return
      }
      if (params && params.tenderId === this.tender.tenderId) {
        this.key = params.key
        this.loading = true
      }
    },
    /**
     * Активируем кнопку
     */
    enableButton(params) {
      if (!this.loading || !params || !params.key) { return }
      if (params.key === this.key) {
        this.loading = false
        this.key = null
      }
    },
    /**
     * Загрузка протокола
     */
    getTenderProtocol: debounce(async function () {
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Завантаження протоколу тендера')
        return
      }
      // const title = this.$t('Tenders.TenderProtocol') //todo
      await this.$notifier.generateTenderProtocolFile( this.$t('Tenders.TenderProtocol')  + ' #' + this.tender.tenderNumber, this.tender.tenderId)
    }, 250),
  },
  components: {
    MenuItem
  }
}
</script>
